import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {getAllData } from "../../../lib/taskmanageview"
import {
  TicketClose,
  TicketOpen,
  TicketTotal,
} from "../../imagepath";

export default  function TaskManageList() {
 
const [tasklist, setTaskList] = useState([])


  async function GetData() {
    const tasks = await getAllData();
    setTaskList(tasks);
    console.log("tasks",tasks);
  }

useEffect(() => {
  GetData();
}, [])


const [tab, setTab] = useState(1);
const toggleTab = (id) => {
  setTab(id);
};

return (
          <div className="col-xl-9 col-md-8">
            <div className="settings-top-widget">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="card stat-info ttl-tickets">
                    <div className="card-body">
                      <img src={TicketTotal} alt="Total Tickets" />
                      <h3>50</h3>
                      <p>Total Tickets</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card stat-info open-tickets">
                    <div className="card-body">
                      <img src={TicketOpen} alt="Open Tickets" />
                      <h3>30</h3>
                      <p>Open Tickets</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="card stat-info close-tickets">
                    <div className="card-body">
                      <img src={TicketClose} alt="Close Tickets" />
                      <h3>20</h3>
                      <p>Close Tickets</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="settings-widget">
              <div className="settings-inner-blk p-0">
                <div className="comman-space pb-0">
                  <div className="filter-grp ticket-grp d-flex align-items-center justify-content-between">
                    <div>
                      <h3>Support Tickets</h3>
                      <p>You can find all of your order Invoices.</p>
                    </div>
                    <div className="ticket-btn-grp">
                      <Link to="/admin/admin-taskmanage-edit/Add">Add New Ticket</Link>
                    </div>
                  </div>

                  {/* Ticket Tab */}
                  <div className="category-tab tickets-tab-blk">
                    <ul className="nav nav-justified ">
                      <li className="nav-item">
                        <Link
                          to="#all"
                          className={
                            tab === 1 ? "nav-link active" : "nav-link"
                          }
                          data-bs-toggle="tab"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTab(1);
                          }}
                        >
                          All
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="#open"
                          className={
                            tab === 2 ? "nav-link active" : "nav-link"
                          }
                          data-bs-toggle="tab"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTab(2);
                          }}
                        >
                          Open
                        </Link>
                      </li>

                      <li className="nav-item">
                        <Link
                          to="#close"
                          className={
                            tab === 4 ? "nav-link active" : "nav-link"
                          }
                          data-bs-toggle="tab"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTab(4);
                          }}
                        >
                          Closed
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* Ticket Tab */}

                  {/* Referred Ticket List */}
                  <div className="tab-content">
                    <div
                      className={
                        tab === 1
                          ? "tab-pane fade show active"
                          : "tab-pane fade"
                      }
                      id="all"
                    >
                      <div className="settings-tickets-blk table-responsive">
                        {/* Referred Users */}
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Topic</th>
                              <th>Student</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                          {tasklist.map(function (data) {
                          return (
                            <tr key={data.id}>
                              <td>
                                <Link to={`/admin/admin-taskmanagedetail/${data.id}`} className="link red">
                                  [Ticket#{data.id}]
                                </Link>
                              </td>
                              <td>
                                <span>{data.subject}</span>
                              </td>
                              <td>{data.studentinfo}</td>
                              <td>
                                {data.status ? 
                                 <span className="badge info-low">Opened</span> : 
                                <span className="badge info-high">
                                  Closed
                                </span>
                                }
                              </td>
                            </tr>
                             )
                            })}

                          </tbody>
                        </table>
                        {/* Referred Users */}
                      </div>
                    </div>

                  </div>
                  {/* Referred Ticket List */}
                </div>
              </div>
            </div>
          </div>
);
}
